import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import createHistory from 'history/createBrowserHistory'

import reducers from '../reducers'

export const history = createHistory();

let initialState = {};
const enhancers = [];
const middleware = [
    routerMiddleware(history),
    thunk,
]

if( typeof(window) !== 'undefined' && '__PRELOADED_STATE__' in window ) {
    initialState = window.__PRELOADED_STATE__;
    delete window.__PRELOADED_STATE__;
}

if( process.env.NODE_ENV === 'development' ) {

    const logger = createLogger({
        level: 'log',
        collapsed: true
    });
    middleware.push(logger);

    const devToolsExtension = window.devToolsExtension;
    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);

const store = createStore(
    reducers,
    initialState,
    composedEnhancers
);

export default store;


// WEBPACK FOOTER //
// ./src/js/config/store.js